import { create } from 'zustand';
import type Geometry from '@arcgis/core/geometry/Geometry.js';

export type SelectionSummary = {
  layer_id: string;
  objectid: string | number;
  display?: string;
  centroid?: { x: number; y: number; wkid?: number };
};

export type SelectionDetail = SelectionSummary & {
  attributes: Record<string, unknown>;
};

type SelectionState = {
  current: SelectionDetail | null;
  set: (detail: SelectionDetail, geometry: Geometry) => void;
  clear: () => void;
};

let liveGeometry: Geometry | null = null;

export const useSelectionStore = create<SelectionState>((set) => ({
  current: null,
  set: (detail, geometry) => {
    liveGeometry = geometry;
    set({ current: detail });
  },
  clear: () => {
    liveGeometry = null;
    set({ current: null });
  },
}));

export function getSelectionGeometry(): Geometry | null {
  return liveGeometry;
}

export function getSelectionSummary(): SelectionSummary | null {
  const cur = useSelectionStore.getState().current;
  if (!cur) return null;
  const { attributes: _a, ...summary } = cur;
  return summary;
}
